import { Container } from '../../styles/global'
import * as S from './styled'

import { useLanguage } from '../../languages/language'

const CV = () => {
  const { texts } = useLanguage()
  return (
    <Container>
      {/*<h1>{texts.cv.title}</h1>*/}
      <h2>{texts.cv.jobs}</h2>
      <S.Timeline>
        {texts.cv.companies.map((company, index) => (
          <S.TimelineItem key={index}>
            <S.Dot />
            <S.Content>
              <h3>
                {company.logo.length > 0 && (
                  <S.Logo>
                    <img alt={company.title} src={company.logo} />
                  </S.Logo>
                )}
                {company.title}
              </h3>
              <S.Subtitle>{company.subtitle}</S.Subtitle>
              <S.Year>{company.years}</S.Year>
              <S.Description>{company.description}</S.Description>
            </S.Content>
          </S.TimelineItem>
        ))}
      </S.Timeline>
      <h2>{texts.cv.education}</h2>
      <S.Timeline>
        {texts.cv.schools.map((school, index) => (
          <S.TimelineItem key={index}>
            <S.Dot />
            <S.Content>
              <h3>{school.title}</h3>
              <S.Subtitle>{school.subtitle}</S.Subtitle>
              <S.Year>{school.years}</S.Year>
            </S.Content>
          </S.TimelineItem>
        ))}
      </S.Timeline>
    </Container>
  )
}
export default CV
